export default {
  white: '#FFFFFF',
  black: '#263238',
  background: '#f3f2ef',
  border: '#d9d8d6',
  tableBackgroundColor: '#e9e9e9',
  tableRowBackgroundColor: '#f7f7f7'
};
